import z from "zod";

import {
    SanityObjectSchema,
    PortableTextBlockSchema,
    LanguageSchema,
    SlugSchema
} from "./sanity";
import { SEOSchema } from "./seo";
import { TagReferenceSchema } from "./tag";

// eslint-disable-next-line import/prefer-default-export
export const BaseArticleSchema = SanityObjectSchema.merge(
    z.object({
        publishedAt: z.string(),
        title: z.string(),
        slug: SlugSchema,
        hidden: z.boolean(),
        type: z.enum(["default", "tip", "Run"]).nullable(),
        body: z.array(PortableTextBlockSchema),
        tags: z.array(TagReferenceSchema).nullable(),
        seo: SEOSchema.nullable(),
        language: LanguageSchema
    })
);
